const { CanvasCircuitApp } = require('../games/circuit/canvasCircuitApp')
const { WebGameApi } = require('./webGameApi')
const { RoiifyBanner } = require('./roiifyBanner')
const { AdbutInterstitial } = require('./adbutInterstitial')

const config = globalThis.CIRCUIT_CONFIG || {}
const adbut = new AdbutInterstitial(config.adbut || {})
const adbutConfigured = adbut.prepare()
const banner = new RoiifyBanner(config.roiify || {})

// A banner changes the available canvas height, so reserve its row before mounting.
if (!adbutConfigured) banner.prepare()

const queryLevel = Number(new URLSearchParams(globalThis.location?.search || '').get('level'))
const configuredLevel = Number(config.game?.level)
const level = Number.isFinite(queryLevel) && queryLevel > 0
  ? queryLevel
  : Number.isFinite(configuredLevel) && configuredLevel > 0
    ? configuredLevel
    : 1
const rawSeed = config.game?.seed
const seed = rawSeed === null || rawSeed === undefined || rawSeed === ''
  ? undefined
  : Number(rawSeed)
const web = new WebGameApi()
const app = new CanvasCircuitApp(web, {
  adbut,
  level,
  seed: Number.isFinite(seed) ? seed : undefined
})

app.mount().catch((error) => {
  console.error('[Neon Circuit] Failed to start:', error)
  const errorElement = document.getElementById('game-error')
  if (errorElement) {
    errorElement.textContent = 'The power grid failed to start. Please refresh and try again.'
    errorElement.hidden = false
  }
})

if (!adbutConfigured) banner.load()
